import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { Affiliate, AffiliateDetail, AffiliateParams } from './affiliate.types';

export const getAffiliateList = (client: AxiosInstance) => async (params: AffiliateParams) => {
  return (await client.get<PaginatedApiResponse<Affiliate[]>>(API_ROUTES.GET_AFFILIATE_LIST, { params })).data;
};

export const getAffiliateDetail = (client: AxiosInstance) => async (affiliateId: string) => {
  return (
    await client.get<ApiResponse<AffiliateDetail>>(API_ROUTES.GET_AFFILIATE_DETAIL, {
      params: { affiliateId: affiliateId || '' },
    })
  ).data;
};

export const affiliatesListQueries = {
  all: () => ['affiliates'],
  list: (params: AffiliateParams) =>
    queryFactoryOptions<PaginatedApiResponse<Affiliate[]>>({
      queryKey: [...affiliatesListQueries.all(), 'list', params],
      queryFn: (client) => () => getAffiliateList(client)(params),
    }),
  detail: (affiliateId: string) =>
    queryFactoryOptions<ApiResponse<AffiliateDetail>>({
      queryKey: [...affiliatesListQueries.all(), 'detail', affiliateId],
      queryFn: (client: AxiosInstance) => () => getAffiliateDetail(client)(affiliateId),
    }),
};
